import { env } from 'common/utils/env'

export const BEVERLY_HILLS_STAGING = 'beverly-hills-staging'
export const LOS_ANGELES_STAGING = 'los-angeles-staging'
export const BEVERLY_HILLS_PRODUCTION = 'beverly-hills'
export const BEVERLY_HILLS_SECOND_PRODUCTION = 'beverly-hills-second'
export const BRENTWOOD = 'brentwood'
export const RESIDEN_CAJ_STAGING = 'residen-caj-staging'

export const SQUARE_APP_ID = env.SQUARE_APPLICATION_ID

export const STRIPE_KEY: string = env.STRIPE_KEY

export const PUSHER_KEYS: Record<string, string> = {
  [BEVERLY_HILLS_STAGING]: env.PUSHER_KEY_SITE_1,
  [LOS_ANGELES_STAGING]: env.PUSHER_KEY_SITE_2,
  [BEVERLY_HILLS_PRODUCTION]: env.PUSHER_KEY_SITE_1,
  [BEVERLY_HILLS_SECOND_PRODUCTION]: env.PUSHER_KEY_SITE_2,
  [BRENTWOOD]: env.PUSHER_KEY_SITE_3,
  [RESIDEN_CAJ_STAGING]: env.PUSHER_KEY_SITE_3,
}

export const PUSHER_CLUSTERS: Record<string, string> = {
  [BEVERLY_HILLS_STAGING]: env.PUSHER_CLUSTER_SITE_1,
  [LOS_ANGELES_STAGING]: env.PUSHER_CLUSTER_SITE_2,
  [BEVERLY_HILLS_PRODUCTION]: env.PUSHER_CLUSTER_SITE_1,
  [BEVERLY_HILLS_SECOND_PRODUCTION]: env.PUSHER_CLUSTER_SITE_2,
  [BRENTWOOD]: env.PUSHER_CLUSTER_SITE_3,
  [RESIDEN_CAJ_STAGING]: env.PUSHER_CLUSTER_SITE_3,
}
